import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import AddPanelTarget from './addPanelTarget'
import * as AC from '../../actions/actionCreators'
import { getSetting } from '../../util/helpers'

function mapStateToProps(state) { 
	return {
        visitorTerritory: state.profile.visitorTerritory,
        targets: state.target.targets,
        isLoadingTargets: state.target.isLoading,
        isLoadingTargetgroups: state.targetgroup.isLoading,
        isSaving: state.request.isSaving,
        error: state.request.error,
        errorPanelChange: state.panelChange.error,
        targetgroups: state.targetgroup.targetgroups,
        isPanelOpen: getSetting(state.setting.settings, "isPanelOpen") === "true",
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchTargetsByName: (name) => { dispatch(AC.TargetListLoadingStarted(name) ) },
        fetchTargetgroups: () => { dispatch(AC.TargetGroupListLoadingStarted()) },
        panelChangeAddTarget: (visitorTerritory, license, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, city, postalCode, address, veevaBrick) => { dispatch(AC.PanelChangeAddTargetStarted(visitorTerritory, license, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, city, postalCode, address, veevaBrick) ) },
        clearTargetSearch: () => { dispatch(AC.ClearTargetSearch()) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) },
        clearPanelChangeUi: () => { dispatch(AC.ClearPanelChangeUi()) }
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddPanelTarget));